import { render, staticRenderFns } from "./ContestListView.vue?vue&type=template&id=0c1906e0&scoped=true&"
import script from "./ContestListView.vue?vue&type=script&lang=js&"
export * from "./ContestListView.vue?vue&type=script&lang=js&"
import style0 from "./ContestListView.vue?vue&type=style&index=0&id=0c1906e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1906e0",
  null
  
)

export default component.exports